var chunkToChildrenMap = {
	"3799": [
		8033
	],
	"4058": [
		8033
	],
	"4465": [
		4174
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));